// extracted by mini-css-extract-plugin
export default {"root":"Dropdown_root__JwQWN","menuItemsRoot":"Dropdown_menuItemsRoot__GfTdb"};